module.exports = __webpack_public_path__ + "img/monitoring-ship-track.2d0edce1.svg";